export default __webpack_public_path__ + "static/media/undraw_add_document_re_mbjx.83ecf122.svg";